export enum CallOrderStatus {
  Created = 'created',
  Packed = 'packed',
  Completed = 'completed',
  Canceled = 'canceled',
}
